import { List } from './list';
import { VisitUiType } from 'store/visits/types';

export const PastVisitorsList = (): JSX.Element => <List type={VisitUiType.PAST} />;
